import { render } from "./PriceIntro.vue?vue&type=template&id=e4a58e4e&scoped=true"
import script from "./PriceIntro.vue?vue&type=script&lang=js"
export * from "./PriceIntro.vue?vue&type=script&lang=js"

import "./PriceIntro.vue?vue&type=style&index=0&id=e4a58e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a58e4e"]])

export default __exports__